module.exports = __webpack_public_path__ + "img/email-header-satisfaction@2x.b01fd5ae.png";